import { render, staticRenderFns } from "./MySupportTicketPreview.vue?vue&type=template&id=4bf3ab2c"
import script from "./MySupportTicketPreview.vue?vue&type=script&lang=js"
export * from "./MySupportTicketPreview.vue?vue&type=script&lang=js"
import style0 from "./MySupportTicketPreview.vue?vue&type=style&index=0&id=4bf3ab2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports